<div
  class="container-filter"
  matMenuContent
  (click)="$event.stopPropagation()"
>
  <div class="search-filter">
    <input
      class="search-filter__input"
      type="text"
      placeholder="Pesquisar por nome"
      (input)="onBuscaChange($event)"
    />
    <mat-icon class="search-filter__icon" svgIcon="magnify"></mat-icon>
  </div>

  <div
    class="item-filter container-filter__padding"
    (scroll)="onScroll($event)"
  >
    <mat-radio-group
      [ngModel]="filtroCorretora"
      (ngModelChange)="onFiltroChange($event)"
    >
      <div class="lista">
        @for(corretora of corretoras(); track corretora.id) {
        <div class="item">
          <mat-radio-button
            class="filter-radio-margin"
            disableRipple
            color="primary"
            [value]="corretora.id"
            labelPosition="before"
            [matTooltip]="corretora.id === matrizId ? 'Administradora do grupo de corretoras' : ''"
          >
            <span class="filter-text" style="cursor: pointer">
              {{ corretora.nomeFan }}
              @if (corretora.id === matrizId) {
                <mat-icon
                  svgIcon="account-cog"
                  style="width:16px;height:16px;font-size:16px;vertical-align:middle;margin-left:6px"
                ></mat-icon>
              }
            </span>
          </mat-radio-button>
        </div>
        }
      </div>
    </mat-radio-group>

    @if (carregando()) {
      <div class="filter-loading">Carregando...</div>
    }

    @if (!carregando() && !erro() && !corretoras().length) {
      <div class="filter-empty">Nenhuma corretora encontrada.</div>
    }

    @if (erro()) {
      <div class="filter-empty">Falha ao carregar corretoras.</div>
    }
  </div>
</div>
